import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		ConfirmDialogComponent
	],
	exports: [
		ConfirmDialogComponent
	]
})
export class ConfirmDialogModule {}
